import { Component, OnDestroy, OnInit } from '@angular/core';

import { ConfigProvider } from "../../config-provider.service";
import { CurrentUser } from "../../common/providers/current-user";
import { OrganizationsNavigationProvider } from '../../organizations/providers/navigation-provider';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { Athlete } from "../../common/models/athlete";
import { User } from "../../common/models/user";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'app-mobile-dashboard',
  providers: [],
  styleUrls: ['./mobile.dashboard.component.scss'],
  standalone: true,
  imports: [
    MobilePageContentComponent,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    RouterLink,
    TranslateModule
  ],
  templateUrl: './mobile.dashboard.component.html'
})
export class MobileDashboardComponent implements OnInit, OnDestroy {

    public pageTitle = 'Mobile.dashboard';
    public isLoading = true;
    public is401 = false;
    public is404 = false;
    public dashboardUrl: string | null = null;
    public athleteUser: User = {} as User;
    public defaultDay: string = '';

    private subscriptions: Subscription[] = [];
    private _currentDate: Date = new Date();

    constructor(
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
        private _utils: UtilsProvider,
        private _organizationNavigation: OrganizationsNavigationProvider,
        private _router: Router,
        private _route: ActivatedRoute,
    ) {
    }

    public ngOnInit(): void {
        this.defaultDay = this._utils.DateToYmd(this._currentDate);
        this.subscriptions.push(
            this._route.data.subscribe((data: any) => { //{ organization: Organization; athlete: Athlete }
                this.athleteUser = data.athlete;
                this.dashboardUrl = data.organization.code + '/app/athletes/' + this.athleteUser.id;
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
